"use client";
import React, { useState } from "react";
import Image from "next/image";
import CheckKYCModal from "@/components/modal/CheckKYCModal";

export default function FreeKYCStrip() { 
  const [isOpen, setIsOpen] = useState(false);
   
  return (
    <>
      <button onClick={() => setIsOpen(true)} className="block text-center mx-auto mb-12 w-full max-w-96 sm:max-w-400 transition duration-200 sm:hover:scale-[1.03] rounded-4xl" aria-label="Check Your KYC For Free">
        <Image src={`/next_assets/images/calculator-pages/Kyc_lead_img.webp`} alt="free kyc check" width={400} height={400} className="rounded-4xl w-full" />
      </button>

      <CheckKYCModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
